import clsx from "clsx"
import type { InputHTMLAttributes, Ref } from "react"

type BaseInputProps = InputHTMLAttributes<HTMLInputElement> & {
  readonly ref?: Ref<HTMLInputElement>
}

export function BaseInput({
  className,
  type = "text",
  ref,
  ...rest
}: BaseInputProps) {
  return (
    <input
      className={clsx(
        className,
        "w-full appearance-none rounded-xs border border-nobel border-solid py-1 pl-1 text-charcoal text-lg outline-hidden transition-all read-only:cursor-default read-only:border-nobel! read-only:text-nobel focus:border-dim focus:ring-1 focus:ring-dim focus:read-only:ring-0 enabled:hover:border-dim disabled:bg-whisper disabled:text-nobel motion-reduce:transition-none lg:text-base",
      )}
      ref={ref}
      type={type}
      // biome-ignore lint: allow passthrough props here
      {...rest}
    />
  )
}
